import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const EditIcon = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M14 14H2M13.2533 4.4283L7.33333 10.4653L4.66667 11.2652L5.44667 8.53046L11.3667 2.45926C11.6171 2.1813 11.9648 2.01656 12.3335 2.00118C12.7022 1.9858 13.0617 2.12104 13.3333 2.37722C13.4621 2.51583 13.5625 2.67958 13.6284 2.85874C13.6943 3.0379 13.7244 3.22881 13.7169 3.42014C13.7094 3.61146 13.6646 3.7993 13.5849 3.97248C13.5053 4.14567 13.3925 4.30068 13.2533 4.4283V4.4283Z'
    stroke={props.color ?? '#0058AD'}
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default EditIcon;
